<template>
    <section class="transaction-conversion-probability">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate"></title-date-component>
        <section class="data-box">
            <line-tips-component style="margin-top:45px;" :lineTipsInfo="lineTipsInfo"></line-tips-component>
            <section class="funnel">
                <section><span>浏览</span></section>
                <section><span>下单</span></section>
                <section><span>支付</span></section>
            </section>
            <section class="data">
                <section>
                    <span title="浏览次数"><i>浏览量</i>{{ data.intentionPv | dataformat }}</span>
                    <span title="浏览用户数量"><i>访客数</i>{{ data.intentionUv | dataformat }}</span>
                </section>
                <section>
                    <span title="所售商品有下单行为的用户数量"><i>下单用户数</i>{{ data.orderUserNum | dataformat }}</span>
                    <span title="所售商品产生的订单数量"><i>订单量</i>{{ data.orderOrderNum | dataformat }}</span>
                </section>
                <section>
                    <span title="产生的支付行为的用户数量"><i>支付用户数</i>{{ data.payUserNum | dataformat }}</span>
                    <span title="产生的支付订单数量"><i>支付订单量</i>{{ data.payOrderNum | dataformat }}</span>
                    <span title="销售额／支付用户数"><i>客单价</i>{{ data.unitPrice }}</span>
                </section>
            </section>
        </section>
        <tips-component :info="info"></tips-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .transaction-conversion-probability {
        background-color: #FFF;
	    padding: 30px 20px 10px 20px;
        margin-top: 20px;
        .data-box {
            width: 100%;
            height: 255px;
            padding-left: 40px;
            margin-top: 35px;
            overflow: hidden;
            .funnel {
                width: 258px;
                height: 100%;
                float: left;
                position: relative;
                left: -90px;
                z-index: 1;
                margin-left: 20px;
                section {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    span {
                        position: absolute;
                        top: -50px;
                        color: #FFF;
                    }
                    &:nth-child(1) {
                        width: 100%;
                        border-top: 85px solid #64C8FD;
                        border-left: 35px solid #FFF;
                        border-bottom: 0;
                        border-right: 35px solid transparent;
                    }
                    &:nth-child(2) {
                        width: 188px;
                        border-top: 85px solid #4AB9FC;
                        border-left: 35px solid transparent;
                        border-bottom: 0;
                        border-right: 35px solid transparent;
                        margin-left: 35px;
                    }
                    &:nth-child(3) {
                        width: 118px;
                        border-top: 85px solid #29A3FC;
                        border-left: 35px solid #FFF;
                        border-bottom: 0;
                        border-right: 35px solid transparent;
                        margin-left: 70px;
                    }
                }
            }
            .data {
                height: 100%;
                float: left;
                width: 52%;
                position: relative;
                left: -60px;
                overflow: hidden;
                > section {
                    height: 85px;
                    &:nth-child(1) {
                        background-color: #F7F9FA;
                    }
                    &:nth-child(3) {
                        background-color: #F7F9FA;
                    }
                    > span {
                        display: inline-block;
                        height: 100%;
                        width: 32%;
                        line-height: 85px;
                        font-size: 22px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        > i {
                            font-size: 14px;
                            font-style: normal;
                            width: 82px;
                            text-align: right;
                            display: inline-block;
                            margin-right: 15px;
                            color: #142C3D;
                            vertical-align: top;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../components/title-date/TitleDate.vue'
    import LineTipsComponent from '../line-tips/LineTips.vue'
    import TipsComponent from '../../../components/tips/Tips.vue'
    import dataformat from '../../../filters/data-format'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../../../filters/moment-format'

    export default {
        components: {
            TitleDateComponent,
            LineTipsComponent,
            TipsComponent
        },
        filters: {
            dataformat
        },
        data () {
            return {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '交易转化概率',  // 名称
                    dateRadio: false,    // 是否显示昨天、本周、本月日期单选框
                    dateRangeSelect: true, // 是否显示日期区间下拉框
                    download: true, // 是否显示下载按钮
                    moduleId: 1,
                    bizCode: this.bizCode
                },
                startDate: MomentFormat.getYestoday(),  // 开始日期，默认昨天
                endDate: MomentFormat.getYestoday(), // 结束日期，默认昨天
                initDateRange: MomentFormat.getYestoday() + ' ~ ' + MomentFormat.getYestoday(),
                data: this.resultData
            }
        },
        computed: {
            // 访购率指标
            lineTipsInfo () {
                return {
                    name: '访购率',
                    value: this.data.purchaseRate,
                    unit: '%',
                    compare: this.data.purchaseRateChg,
                    title: '支付用户数／浏览用户数'
                }
            },

            // 底部建议
            info () {
                return {
                    value: this.data.purchaseRateChg,
                    title: "您经营的商品访购率与上一周期相比",
                    suggest: "访购率是您经营的转化的重要指标，优化商品市场定位、商品描述、商品服务、价格对访购率的提升会所帮助。"
                }
            }
        },
        props: ["resultData", "bizCode"],
        watch: {
            resultData: {
                handler: function () {
                    this.data = this.resultData;
                },
                deep: true
            }
        },
        methods: {
            getData () {
                DataPlatform.getOperationData(this.bizCode, this.startDate, this.endDate)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.data = res.data;
                        } else {
                            this.data = {};
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        this.data = {};
                        console.log(err);
                    })
            },

            // 切换日期
            changeDate (params) {
                this.startDate = params.dateRange.startDate;
                this.endDate = params.dateRange.endDate;
                this.getData();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// TransactionConversionProbability.vue?3db63b36